export default __webpack_public_path__ + "static/media/17.e908905c.pdf";